<!-- 
Invoices listing page.
-->
<template>
  <div class="home">
    <our-heading 
      :breadcrumbs="breadcrumbs"
      title="Invoices"
      user-guide-topic="listing-invoices"
    />
    <our-search-bar>
      <our-quick-search 
        slot="quick-search"
        :criteria-mutation="criteriaMutation" 
        :value="quickSearch"
        label="Provider name or SAP doc ID" 
        field="providerName" 
        field-if-numeric="sapDocumentIdentifier" 
        @changed="$refs.invoices.refresh()"
      />
      <our-search-button 
        slot="search-button"
        :criteria="criteria" 
        :criteria-mutation="criteriaMutation" 
        :search-filters="searchFilters" 
        title="Search invoices"
        @changed="$refs.invoices.refresh()"
      />
      <our-saved-searches-menu 
        slot="saved-searches-button"
        :criteria="criteria"
        :criteria-mutation="criteriaMutation" 
        :clear-criteria-mutation="clearCriteriaMutation"
        module="invoices" 
        @selected="$refs.invoices.refresh()"
      />
    </our-search-bar>
    <invoice-listing ref="invoices" @click="open"/>
  </div>
</template>

<script>
import * as mutation from "@/store/invoices/mutation-types";
import InvoiceListing from "@/components/invoices/InvoiceListing.vue";
import { getSearchFilters } from "@/store/invoices/helpers";

export default {
  name: "Invoices",
  components: { InvoiceListing },
  data() {
    return {
      criteriaMutation: mutation.LIST_SET_CRITERIA,
      clearCriteriaMutation: mutation.LIST_CLEAR_CRITERIA
    };
  },
  computed: {
    criteria() {
      return this.$store.state.invoices.listing.criteria;
    },
    quickSearch() {
      return this.criteria.sapDocumentIdentifier && !this.criteria.providerName
        ? this.criteria.sapDocumentIdentifier
        : this.criteria.providerName;
    },
    searchFilters() {
      return getSearchFilters();
    },
    breadcrumbs() {
      return [{ text: "Invoices" }];
    }
  },
  methods: {
    open(id) {
      this.$router.push({ path: `/invoices/${id}` });
    }
  }
};
</script>
